var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{class:_vm.$style.container},[(_vm.activities.length)?_c('ol',_vm._l((_vm.activities),function(activity){return _c('li',{key:activity.id},[_c('CallInfo',{class:_vm.$style.callInfo,attrs:{"activity":activity,"info":[],"actions":['summarize', 'take-notes', 'play']}})],1)}),0):_c('p',{class:_vm.$style.noTasks},[_vm._v("There are no tasks to do 🎉")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de97386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Tasks.vue
// module id = fEOw
// module chunks = 1